<div appCustomScroll #appScrollElement="appCustomScroll" #scroll style="overflow-y: auto; height: calc(100vh - 176px);">
  <div class="container-fluid">
    <br/><br/>
    <!--    top form start-->
    <div class="row justify-content-center">
      <div class="col-11">
        <span class="rm-title rm-title-3">Deal Information</span><br/>
        <span
          class="rm-title rm-title-6 rm-lighter">This is where you can take a detailed look at this deal's information.</span>
      </div>
    </div>

    <div class="row justify-content-center" style="padding-top: 25px;">
      <div class="col-11" id="card-title">
        <span style="font-size: large;"><b>{{ deal.projectName }}</b></span><br/>
        <span style="font-size: small; color: grey">{{ deal.assetName }}</span><br/>
      </div>
    </div>

    <div class="row justify-content-center" style="padding-top:15px; padding-bottom: 25px;">
      <div class="col-11 col-xl-5 img-card">
        <div class="row" style="padding-bottom: 15px;">
          <div class="col-12" style="padding-bottom: 15px;">
            <!--    the pills-->
            <div id="card-pills" *ngFor="let p of deal.pills"
                 class="rounded-pill" [matTooltip]="p.tooltip" matTooltipPosition="right"
                 [ngStyle]="{'background-color': p.backgroundColor, 'color':p.fontColor, 'border-color': p.borderColor}"
            ><span style="font-size: 10px; width: 100%;">{{ p.name.toUpperCase() }}</span>
            </div>
          </div>
          <!--      image-->
          <div class="col-12" style="padding: 0 0 0 12px;" (mouseenter)="hovering=true;" (mouseleave)="hovering=false;">
            <div id="card-img-top">
              <img id="img-top" [class]="getImgClass()" [src]="deal.dealImageUrl"
                   style="object-fit: cover; border-radius: 12px;"
                   [default]="'/assets/images/image-placeholder.png'"
                   alt="Deal Image Broken :(">
            </div>
          </div>
        </div>
      </div>
      <!--      title-->
      <div  class="col-11 col-xl-6">
        <div class="row justify-content-center">
          <div class="col-12 col-xl-9">
            <!--    MOIC-->
            <div class="row justify-content-start">
              <div class="col-9">
                <span style="font-size: large; color: #002150;">MOIC (Modeled Returns)</span><br />
                <em class="text-muted">Return metrics modelled by the GP</em>
              </div>
            </div>
            <div class="metrics-container mt-2">
              <div class="metric">
                  <span class="metric-label">Bear Case</span>
                  <span class="metric-value">{{deal.targetMoicBear}} x</span>
              </div>
              <div class="metric">
                  <span class="metric-label">Base Case</span>
                  <span class="metric-value">{{deal.targetMoicBase}} x</span>
              </div>
              <div class="metric">
                  <span class="metric-label">Best Case</span>
                  <span class="metric-value">{{deal.targetMoicBest}} x</span>
              </div>
            </div>

            <br/>
            <!--    DURATION-->
            <div class="row justify-content-start" style="padding-top:10px;">
              <div class="col-9">
                <span style="font-size: large; color: #002150;">Duration</span><br />
                <em class="text-muted">Return metrics modelled by the GP</em>
              </div>
            </div>
            <div class="metrics-container mt-2">
                <div class="metric">
                    <span class="metric-label">Min Duration</span>
                    <span class="metric-value">{{deal.minimumDuration}} years</span>
                </div>
                <div class="metric">
                    <span class="metric-label">Expected Duration</span>
                    <span class="metric-value">{{deal.expectedDuration}} years</span>
                </div>
                <div class="metric">
                    <span class="metric-label">Max Duration</span>
                    <span class="metric-value">{{deal.maximumDuration}} years</span>
                </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--    info section-->
    <div class="row justify-content-center" style="padding-bottom:150px;">
      <div class="col-11" style="overflow: auto;">
        <table id="info-table" style="border: thin solid #738fbd;">
          <tr class="info-row">
            <td class="info-title-cell">
              <span class="info-title">Asset Class</span>
            </td>
            <td style="padding-left: 10px;">
              <!--              {{getDealType(deal?.secDealType)}}-->
              <div *ngIf="!!deal.assetClasses" style="display: flex;">
                <div *ngFor="let a of deal.assetClasses" class="chip">
                  {{ a }}
                </div>
              </div>
            </td>
          </tr>
          <tr class="info-row">
            <td class="info-title-cell">
              <span class="info-title">Deal Type</span>
            </td>
            <td style="padding-left: 10px;">
              <!--              {{getDealType(deal?.secDealType)}}-->
              <div *ngIf="!!deal.dealTypes" style="display: flex;">
                <div *ngFor="let a of deal.dealTypes" class="chip">
                  {{ a }}
                </div>
              </div>
            </td>
          </tr>
          <tr class="info-row">
            <td class="info-title-cell">
              <span class="info-title">Total Fundraise Size ($M)</span>
            </td>
            <td style="padding-left: 10px;">
              <!--              {{getNDARequirementType(deal?.dealNdaRequirementType)}}-->
              {{ deal.fundraiseSize | currency: 'USD':'symbol':'2.0' }}
            </td>
          </tr>
          <tr class="info-row">
            <td class="info-title-cell">
              <span class="info-title">Close Date</span>
            </td>
            <td style="padding-left: 10px;">
              {{ deal.closeDate | date : 'mediumDate' : 'UTC' }}
            </td>
          </tr>
          <tr class="info-row">
            <td class="info-title-cell">
              <span class="info-title">Deal Close Type</span>
            </td>
            <td style="padding-left: 10px;">
              {{ deal.dealCloseType }}
            </td>
          </tr>
          <tr class="info-row">
            <td class="info-title-cell" colspan="2">
              <span class="info-title">Transaction Description</span>
            </td>
          </tr>
          <tr style="padding-bottom: 50px;">
            <td colspan="2" style="padding: 10px 25px;">
              <span [innerHTML]="deal.description"></span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
